import SharedSortableLists from "./SharedSortableLists";
import AreaDirectorStoreProductsIndex from "./AreaDirectorStoreProductsIndex";

export default class SortableStoreProductsList extends SharedSortableLists {
  reactTableComponent() {
    return AreaDirectorStoreProductsIndex;
  }

  defaultSortKey() {
    return "name";
  }

  sortData() {
    switch (this.sortKey) {
      case "name":
        return this.sortBy({ attr: "publication_name" });
      case "status":
        return this.sortBy({ attr: "nice_status" });
      case "pages":
        return this.sortBy({ attr: "page_count" });
      case "date":
        return this.sortBy({ attr: "modified_at" });
      default:
        return "";
    }
  }
}
